<div class="page-content-wrapper">
  <div class="card shadow border-1 rounded-3">
    <div class="card-header bg-white border-0 me-2">
      <p class="text-s fw-bold">Workflow Notifications</p>
    </div>
    <div class="card-body">
      <div class="mb-4">
        <div class="d-flex justify-content-start align-items-center gap-5">
          <div class="form-check p-0">
            <input class="form-check-input me-2" type="radio" name="emailOption" id="enterEmail" value="enter"
              v-model="selectedEmailOption" @change="handle_email_option_change">
            <label class="form-check-label fw-medium label-small" for="enterEmail">
              Enter External Email
            </label>
          </div>
          <div class="form-check p-0">
            <input class="form-check-input me-2" type="radio" name="emailOption" id="selectEmail" value="select"
              v-model="selectedEmailOption" @change="handle_email_option_change">
            <label class="form-check-label fw-medium label-small" for="selectEmail">
              Select Internal Email
            </label>
          </div>
        </div>
      </div>

      <div v-if="selectedEmailOption === 'enter'" class="mb-3 ms-1">
        <div class="card border-light bg-light p-3 max-width-500">
          <div class="mb-3">
            <label for="emailInput" class="form-label">Email</label>
            <input type="email" class="form-control" id="emailInput" v-model="enteredEmail"
              placeholder="Enter email address" :class="{ 'is-invalid': emailError }">
            <div v-if="emailError" class="invalid-feedback d-block">
              {{ emailError }}
            </div>
          </div>
          <div class="d-flex gap-3">
            <button type="button" class="btn btn-danger btn-sm text-xxs fw-bold text-white rounded-small shadow"
              @click="cancel_email">Cancel</button>
            <button type="button" class="btn bg-green btn-sm text-xxs fw-bold rounded-3 shadow"
              @click="save_email">Save</button>
          </div>
        </div>
      </div>

      <div v-if="selectedEmailOption === 'select'" class="mb-3 ms-1">
        <div class="card border-light bg-light p-3 max-width-500">
          <div class="mb-3">
            <label for="emailSearch" class="form-label">Select a User Email:</label>
            <div class="email-dropdown-search">
              <input 
                type="text" 
                class="form-control search-input" 
                id="emailSearch"
                v-model="searchQuery"
                @input="filterEmails"
                @focus="onSearchFocus"
                @blur="onSearchBlur"
                placeholder="Search for user email..."
                :disabled="isLoadingUsers"
                autocomplete="off"
              >
              
              <div v-if="showDropdown && filteredEmailOptions.length > 0" class="email-dropdown-menu show">
                <div 
                  v-for="email in filteredEmailOptions" 
                  :key="email.id" 
                  class="email-dropdown-item"
                  @mousedown="selectEmail(email)"
                >
                  {{ email.name }} - {{ email.address }}
                </div>
              </div>
              
              <div v-if="showDropdown && filteredEmailOptions.length === 0 && !isLoadingUsers && emailOptions.length > 0" class="email-dropdown-menu show">
                <div class="email-dropdown-no-results">No users found</div>
              </div>
              
              <div v-if="showDropdown && isLoadingUsers" class="email-dropdown-menu show">
                <div class="email-dropdown-no-results">
                  <div class="spinner-border spinner-border-sm me-2" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  Loading users...
                </div>
              </div>
            </div>
          </div>
          <div v-if="emailOptions.length === 0 && !isLoadingUsers" class="text-muted small mb-3">
            No users found or failed to load users.
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="table-responsive">
          <table id="workflow-notification-users" class="table table-clear">
            <thead class="bg-dark text-white">
              <tr>
                <th class="text-uppercase text-xxs">ID</th>
                <th class="text-uppercase text-xxs">EMAIL</th>
                <th class="text-uppercase text-xxs text-start">DATE ADDED</th>
                <th class="text-uppercase text-xxs text-start">ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in notificationUsers" :key="user.id">
                <td class="text-xxs text-start">{{ index + 1 }}</td>
                <td class="text-xxs">{{ user.first_name }}</td>
                <td class="text-xxs text-start">{{ user.date_created }}</td>
                <td>
                  <button class="btn btn-danger btn-sm text-xxs fw-bold text-white rounded-small shadow"
                    @click="remove_notification(user.id)">Remove</button>
                </td>
              </tr>
              <tr v-if="notificationUsers.length === 0">
                <td colspan="4" class="text-center py-4 text-muted">
                  No user emails added yet. Use the options above to add emails.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
